if (!customElements.get('eme-product-guide')) {
  customElements.define('eme-product-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.selected = 0;
      this.media = matchMedia('(min-width: 750px)');
      this.click = event => {
        const button = event.target.closest('[data-guide-tab]');
        if (button) this.select(Number(button.dataset.guideTab));
      };
      this.key = event => {
        const current = event.target.closest('[data-guide-tab]');
        if (!current || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const count = this.querySelectorAll('[data-guide-tab]').length;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? count - 1 : (this.selected + (event.key === 'ArrowRight' ? 1 : -1) + count) % count;
        this.select(next);
        this.querySelectorAll('[data-guide-tab]')[next]?.focus();
      };
      this.change = () => this.configure();
      this.addEventListener('click',this.click);
      this.addEventListener('keydown',this.key);
      this.media.addEventListener('change',this.change);
      this.configure();
    }
    select(index) {
      this.selected = index;
      this.querySelectorAll('[data-guide-tab]').forEach((button,i) => {
        button.setAttribute('aria-selected',String(i === index));
        button.tabIndex = i === index ? 0 : -1;
      });
      this.querySelectorAll(':scope > [data-guide-panel]').forEach((panel,i) => { panel.open = i === index; });
    }
    configure() {
      const desktop = this.media.matches;
      this.dataset.tabs = String(desktop);
      this.querySelector('[role=tablist]').hidden = !desktop;
      this.querySelectorAll(':scope > [data-guide-panel]').forEach(panel => {
        if (desktop) { panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',panel.dataset.tabId); }
        else { panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); }
      });
      this.select(this.selected);
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.click);
      this.removeEventListener('keydown',this.key);
      this.media?.removeEventListener('change',this.change);
      this.connected = false;
    }
  });
}
